export const SET_EVENT = 'SET_EVENT'
export const SET_PARAM = 'SET_PARAM'
export const SET_PARAMS = 'SET_PARAMS'
export const CLEAR_PARAM = 'CLEAR_PARAM'
